import axios from "axios";
import { configUrl } from "../../config";

const getAllSubscriptionsService = async (userId) => {
    try {
        let response = await axios.get(
            `${configUrl.AssessmentServer}/api/UserSubscription/getAllSubscriptions`
        );
        let data = response?.data?.$values;


        return data;
    } catch (error) {
        console.log("erro fetchng the subscriptions");
    }

};

export default getAllSubscriptionsService;